import React, { Component } from "react";
import "../style/Contact.css";
import axios from "axios";
import emailValidation from "../services/emailValidation";
import { Link } from "react-router-dom";

export class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: false,
      contactHeath: false,
      contactSam: false,
      samMessage: "",
      heathMessage: "",
      senderEmail: "",
      submitError: "",
      submitResponse: null,
    };
    this.selectSam = this.selectSam.bind(this);
    this.selectHeath = this.selectHeath.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.setState({ animation: true });
  }
  selectSam() {
    this.setState((prevState) => {
      return {
        contactSam: !prevState.contactSam,
        contactHeath: false,
        heathMessage: "",
      };
    });
  }
  sendTo() {
    if (this.state.contactHeath) return "heath";
    if (this.state.contactSam) return "sam";
    else return "sam";
  }
  selectHeath() {
    this.setState((prevState) => {
      return {
        contactHeath: !prevState.contactHeath,
        contactSam: false,
        samMessage: "",
      };
    });
  }
  async handleSubmit() {
    this.setState({ submitError: "" });

    if (this.state.senderEmail.length < 1) {
      this.setState({ submitError: "You must give us your email" });
    }
    if (
      this.state.heathMessage.length < 1 &&
      this.state.samMessage.length < 1
    ) {
      this.setState({
        submitError: "You have to have a message of 10 or more characters!",
      });
    }
    if (this.state.senderEmail) {
      if (emailValidation(this.state.senderEmail) === false) {
        this.setState({ submitError: `Your email doesn't look right` });
      }

      const data = {
        message: this.state.heathMessage || this.state.samMessage,
        senderEmail: this.state.senderEmail,
        sendTo: this.sendTo(),
      };
      const result = await axios.post(
        "https://agile-ocean-79433.fly.dev/contact/message",
        data
      );

      this.setState({ submitResponse: result.data.message });
      this.setState({
        contactHeath: false,
        contactSam: false,
        samMessage: "",
        heathMessage: "",
        senderEmail: "",
        submitError: "",
      });
    }
  }
  renderSam() {
    return (
      <div>
        <textarea
          onChange={(e) => this.setState({ samMessage: e.target.value })}
          value={this.state.samMessage}
          cols="30"
          rows="5"
          placeholder="Describe the technical problem you're having. What browser are you using?"
        />
        <div>
          <button onClick={this.handleSubmit} className="btn contact-btn">
            Send message
          </button>
        </div>
        <div className="contact-input">
          <input
            onChange={(e) => this.setState({ senderEmail: e.target.value })}
            type="text"
            className="sign-input"
            placeholder="Your email so that we can contact you"
          />
        </div>
      </div>
    );
  }
  renderHeath() {
    return (
      <div>
        <textarea
          onChange={(e) => this.setState({ heathMessage: e.target.value })}
          value={this.state.heathMessage}
          cols="30"
          rows="5"
          placeholder="Tell us something: thanks, request a motet, point out errata, anything (with manners)!"
        />
        <div>
          <button onClick={this.handleSubmit} className="btn contact-btn">
            Send message
          </button>
        </div>
        <div className="contact-input">
          <input
            onChange={(e) => this.setState({ senderEmail: e.target.value })}
            type="text"
            className="sign-input"
            placeholder="Your email so that we can contact you"
          />
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
        <div
          className={
            this.state.animation
              ? "animate-in contact-container"
              : "contact-container"
          }
        >
          <div className="contact-card-title">
            <h1>Contact us!</h1>
          </div>
          <div className="contact-journey">
            <div className="start">
              <h2>What would you like to contact us about?</h2>
              <div className="options">
                <h3
                  onClick={this.selectHeath}
                  className={
                    this.state.contactHeath ? "option option-active" : "option"
                  }
                >
                  The music
                </h3>
                <h3
                  onClick={this.selectSam}
                  className={
                    this.state.contactSam ? "option option-active" : "option"
                  }
                >
                  A technical issue
                </h3>
              </div>
            </div>
            {this.state.submitError && (
              <p className="contact-error">{this.state.submitError}</p>
            )}
            {this.state.submitResponse && (
              <p className="contact-success">{this.state.submitResponse}</p>
            )}
            {this.state.contactHeath && this.renderHeath()}
            {this.state.contactSam && this.renderSam()}

            <div id="information" className="contact-card-title">
              <h1>Terms and Privacy Policy</h1>
            </div>
            <div style={{ textAlign: "left", margin: "0 10%" }}>
              <p>
                To review our terms: <Link to="/terms">click here</Link>
              </p>
              <p>
                To review our privacy policy:{" "}
                <Link to="/privacy">click here</Link>
              </p>
            </div>

            <div id="" className="contact-card-title">
              <h1>Pricing</h1>
            </div>
            <div style={{ textAlign: "left", margin: "0 10%" }}>
              <p>Pricing is a one-time payment of $30.</p>
            </div>
            <div id="" className="contact-card-title">
              <h1>Returns and Refunds Policy for Digital Products</h1>
            </div>
            <div style={{ textAlign: "left", margin: "0 10%" }}>
              <p>
                Please read this policy carefully. This is the Return and Refund
                Policy of English Motets. This Return and Refund Policy for
                English Motets is managed by TermsFeed's Return Refund Policy
                Generator.
              </p>
              <p>
                We do not issue refunds for digital products once the order is
                confirmed and the product is accessible. We recommend contacting
                us for assistance if you experience any issues receiving or
                downloading our products.
              </p>
              <p>
                If you have any questions about our Returns and Refunds Policy,
                please contact us: via the form above or by directly contacting{" "}
                <a href="mailto:heath.morber@gmail.com">
                  heath.morber@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js